/* Valentina Díaz · Test de inflamación "¿Qué te dice tu cuerpo?" */
(function () {
  'use strict';

  var SCALE = [['Nunca', 0], ['A veces', 1], ['Con frecuencia', 2], ['Casi siempre', 3]];

  var CONTEXT = [
    { id: 'sexo', q: '¿Eres mujer u hombre?', opts: [['mujer', 'Mujer'], ['hombre', 'Hombre']] },
    { id: 'edad', q: '¿Cuántos años tienes?', opts: [['lt30', 'Menos de 30'], ['30s', '30 a 39'], ['40s', '40 a 49'], ['50s', '50 a 59'], ['60s', '60 o más']] },
    { id: 'programa', q: '¿Ya hiciste un programa conmigo?', opts: [['si', 'Sí'], ['no', 'No']] },
    { id: 'diabetes', q: '¿Tienes familiares cercanos con diabetes?', opts: [['si', 'Sí'], ['no', 'No'], ['ns', 'No lo sé']] }
  ];

  /* Se pregunta al final, cuando la persona ya recorrió los síntomas. Se omite si no marcó ninguno. */
  var AFTER = [
    { id: 'tiempo', q: '¿Hace cuánto sientes estas molestias?', opts: [['lt3', 'Menos de 3 meses'], ['3a6', 'De 3 a 6 meses'], ['gt6', 'Más de 6 meses'], ['gt12', 'Más de un año']] }
  ];

  var ORDER = ['digestivo', 'nervioso', 'hormonal', 'metabolico', 'muscular'];

  /* La etapa hormonal se infiere del sexo y la edad: menos de 40, ciclo; 40 a 49, perimenopausia; 50 o más, menopausia. */
  function etapaDe(ctx) {
    if (ctx.sexo === 'hombre') return 'hombre';
    if (ctx.edad === 'lt30' || ctx.edad === '30s') return 'ciclo';
    if (ctx.edad === '40s') return 'peri';
    if (ctx.edad === '50s' || ctx.edad === '60s') return 'meno';
    return 'peri';
  }

  function hormonalUno(ctx) {
    var etapa = etapaDe(ctx);
    if (etapa === 'hombre') return 'Menor fuerza o resistencia física que antes';
    if (etapa === 'meno') return 'Sofocos o sudoración nocturna';
    if (etapa === 'ciclo') return 'Ciclos irregulares o síndrome premenstrual fuerte';
    return 'Ciclos irregulares, sofocos o sudoración nocturna';
  }

  function cinturaOpts(ctx) {
    if (etapaDe(ctx) === 'hombre') return [['Menos de 94 cm', 0], ['Entre 94 y 102 cm', 2], ['Más de 102 cm', 3], ['No la sé', 0]];
    return [['Menos de 80 cm', 0], ['Entre 80 y 88 cm', 2], ['Más de 88 cm', 3], ['No la sé', 0]];
  }

  var QUESTIONS = {
    digestivo: [
      'Hinchazón, distensión o gases después de comer',
      'Dolor o molestia abdominal',
      'Estreñimiento, diarrea o alternancia entre ambos',
      'Reflujo, acidez o ardor',
      'Alimentos que antes tolerabas y ahora te caen mal'
    ],
    nervioso: [
      'Cansancio aunque hayas dormido bien',
      'Niebla mental o dificultad para concentrarte',
      'Dificultad para dormir o despertares en la noche',
      'Ansiedad, irritabilidad o ánimo bajo',
      'Dolores de cabeza'
    ],
    hormonal: [
      hormonalUno,
      'Acné, brotes o piel apagada',
      'Caída del cabello',
      'Retención de líquidos',
      'Bajo deseo sexual'
    ],
    metabolico: [
      'Antojos fuertes de dulce o harinas',
      'Sueño o bajón de energía después de comer',
      'Dificultad para bajar de peso aunque te cuides',
      { q: '¿Cuánto mide tu cintura?', opts: cinturaOpts, plain: true },
      'Hambre o irritabilidad si pasas pocas horas sin comer'
    ],
    muscular: [
      'Dolor o rigidez en las articulaciones',
      'Rigidez al despertar que tarda en pasar',
      'Dolores musculares sin haber hecho esfuerzo',
      'Tensión o dolor en cuello, hombros o espalda',
      'Recuperación lenta después de hacer ejercicio'
    ]
  };

  var ALARMS = [
    ['sangre', 'Sangre en las heces'],
    ['peso', 'Pérdida de peso sin razón'],
    ['fiebre', 'Fiebre que no se va'],
    ['articulaciones', 'Articulaciones hinchadas o calientes'],
    ['rigidez', 'Rigidez al despertar que dura más de una hora']
  ];

  /* ---------- Lógica (sin DOM) ---------- */
  function buildSteps() {
    var steps = [];
    CONTEXT.forEach(function (c) { steps.push({ type: 'ctx', id: c.id }); });
    ORDER.forEach(function (sys) {
      QUESTIONS[sys].forEach(function (_, i) { steps.push({ type: 'q', sys: sys, i: i }); });
    });
    AFTER.forEach(function (c) { steps.push({ type: 'ctx', id: c.id, after: true }); });
    steps.push({ type: 'alarm' });
    return steps;
  }

  function compute(cfg, state) {
    var ans = state.ans || {};
    var ctx = state.ctx || {};
    var scores = {};
    var total = 0;
    ORDER.forEach(function (sys) {
      var s = 0;
      for (var i = 0; i < 5; i++) s += Number(ans[sys + '.' + i] || 0);
      scores[sys] = s;
      total += s;
    });
    var ranked = ORDER.slice().sort(function (a, b) { return scores[b] - scores[a] || ORDER.indexOf(a) - ORDER.indexOf(b); });
    var top = ranked[0];
    var second = (scores[ranked[1]] > 0 && scores[top] - scores[ranked[1]] <= 2) ? ranked[1] : null;

    var level = null;
    (cfg.levels || []).forEach(function (l) { if (total >= l.min && total <= l.max) level = l; });

    var flags = {
      piel_cabello: Number(ans['hormonal.1'] || 0) + Number(ans['hormonal.2'] || 0) >= 4,
      digestivo_cronico: top === 'digestivo' && (ctx.tiempo === 'gt6' || ctx.tiempo === 'gt12'),
      ya_hizo_programa: ctx.programa === 'si'
    };
    var alarm = (state.alarms || []).length > 0;

    var candidates = (cfg.products || []).filter(function (p) {
      if (p.min === null || p.min === undefined || p.max === null || p.max === undefined) return false;
      if (total < p.min || total > p.max) return false;
      if (p.cond && !flags[p.cond]) return false;
      return true;
    }).sort(function (a, b) { return (b.prio || 0) - (a.prio || 0); });
    var main = candidates[0] || null;

    var complements = (cfg.products || []).filter(function (p) {
      return p.comp && flags[p.comp] && (!main || p.handle !== main.handle);
    });

    return { scores: scores, total: total, ranked: ranked, top: top, second: second, level: level, flags: flags, alarm: alarm, main: main, complements: complements };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { compute: compute, buildSteps: buildSteps, ORDER: ORDER, QUESTIONS: QUESTIONS, CONTEXT: CONTEXT, AFTER: AFTER, etapaDe: etapaDe, cinturaOpts: cinturaOpts, hormonalUno: hormonalUno };
    return;
  }

  /* ---------- Interfaz ---------- */
  var root = document.querySelector('[data-vd-test]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(root.querySelector('[data-vd-test-config]').textContent); } catch (e) { return; }

  var KEY = 'vdTestV3';
  var intro = root.querySelector('[data-vd-intro]');
  var stageEl = root.querySelector('[data-vd-stage]');
  var formWrap = root.querySelector('[data-vd-form-wrap]');
  var form = formWrap ? formWrap.querySelector('form') : null;
  var steps = buildSteps();
  var T = cfg.texts || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fresh() { return { stage: 'intro', idx: 0, ctx: {}, ans: {}, alarms: [], alarmsDone: false }; }
  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return fresh();
      var s = JSON.parse(raw);
      if (!s || typeof s !== 'object' || !s.stage) return fresh();
      s.ctx = s.ctx || {}; s.ans = s.ans || {}; s.alarms = s.alarms || [];
      return s;
    } catch (e) { return fresh(); }
  }
  function save() { try { window.localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function clear() { try { window.localStorage.removeItem(KEY); } catch (e) {} }

  var state = load();
  if (root.querySelector('[data-vd-form-error]') && state.stage === 'resultado') { state.stage = 'datos'; }

  function esc(s) {
    return String(s === null || s === undefined ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function nl(s) { return esc(s).replace(/\n/g, '<br>'); }
  function sysCfg(key) { return (cfg.systems || {})[key] || { label: key, short: key }; }

  function show(which) {
    if (intro) intro.hidden = which !== 'intro';
    stageEl.hidden = which === 'intro';
    if (formWrap) formWrap.hidden = which !== 'datos';
  }

  function focusTop() {
    var h = stageEl.querySelector('[data-vd-focus]');
    var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
  }

  function progress() {
    var pct = Math.round(((state.idx) / steps.length) * 100);
    return '<div class="vd-test__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
  }

  function backBtn() {
    return '<button type="button" class="vd-test__back" data-vd-back>← Volver</button>';
  }

  function optionsHtml(opts, current) {
    return '<div class="vd-test__opts">' + opts.map(function (o, n) {
      var sel = current !== undefined && current !== null && String(current) === String(n);
      return '<button type="button" class="vd-test__opt' + (sel ? ' is-selected' : '') + '" data-vd-opt="' + n + '" aria-pressed="' + (sel ? 'true' : 'false') + '">' + esc(o[0]) + '</button>';
    }).join('') + '</div>';
  }

  function ctxDef(id) {
    return CONTEXT.concat(AFTER).filter(function (x) { return x.id === id; })[0];
  }

  /* La pregunta de tiempo no aplica si la persona no marcó ningún síntoma. */
  function skipStep(i) {
    var st = steps[i];
    return !!st && st.type === 'ctx' && st.after && compute(cfg, state).total === 0;
  }

  function renderStep() {
    var st = steps[state.idx];
    var html = progress();
    if (st.type === 'ctx') {
      var c = ctxDef(st.id);
      var n = CONTEXT.indexOf(c);
      var cur = null;
      c.opts.forEach(function (o, k) { if (o[0] === state.ctx[c.id]) cur = k; });
      if (st.after) html += '<p class="vd-kicker">' + esc(T.afterTitle || 'Ya casi terminamos') + '</p>';
      else html += '<p class="vd-kicker">' + esc(T.ctxTitle || 'Antes de empezar') + ' · ' + (n + 1) + ' de ' + CONTEXT.length + '</p>';
      html += '<h2 class="vd-h vd-test__q" tabindex="-1" data-vd-focus>' + esc(c.q) + '</h2>';
      html += optionsHtml(c.opts.map(function (o) { return [o[1]]; }), cur);
    } else if (st.type === 'q') {
      var q = QUESTIONS[st.sys][st.i];
      var plain = typeof q === 'object' && q.plain;
      var text = typeof q === 'function' ? q(state.ctx) : (typeof q === 'object' ? q.q : q);
      var opts = (typeof q === 'object' && q.opts) ? q.opts(state.ctx) : SCALE;
      var key = st.sys + '.' + st.i;
      html += '<p class="vd-kicker">' + esc(sysCfg(st.sys).label) + ' · ' + (st.i + 1) + ' de 5</p>';
      if (!plain) html += '<p class="vd-test__lead">' + esc(T.instruction || 'En las últimas 4 semanas, ¿con qué frecuencia has sentido esto?') + '</p>';
      html += '<h2 class="vd-h vd-test__q" tabindex="-1" data-vd-focus>' + esc(text) + '</h2>';
      html += optionsHtml(opts, state['sel.' + key] !== undefined ? state['sel.' + key] : null);
    } else {
      html += '<p class="vd-kicker">' + esc(T.alarmKicker || 'Por tu seguridad') + '</p>';
      html += '<h2 class="vd-h vd-test__q" tabindex="-1" data-vd-focus>' + esc(T.alarmTitle || 'Una última pregunta, por tu seguridad') + '</h2>';
      html += '<p class="vd-test__lead">' + esc(T.alarmText || '¿Has tenido algo de esto en los últimos meses? Puedes marcar varias.') + '</p>';
      html += '<div class="vd-test__checks">' + ALARMS.map(function (a) {
        var on = state.alarms.indexOf(a[0]) > -1;
        return '<label class="vd-test__check"><input type="checkbox" value="' + a[0] + '"' + (on ? ' checked' : '') + ' data-vd-alarm><span>' + esc(a[1]) + '</span></label>';
      }).join('') + '<label class="vd-test__check"><input type="checkbox" value="none"' + (state.alarmsDone && !state.alarms.length ? ' checked' : '') + ' data-vd-alarm><span>Ninguna de estas</span></label></div>';
      html += '<div class="vd-actions"><button type="button" class="vd-btn vd-btn--primary" data-vd-alarm-next>Ver mi resultado</button></div>';
      html += '<p class="vd-test__error" data-vd-alarm-error hidden>Marca al menos una opción para continuar.</p>';
    }
    if (state.idx > 0) html += backBtn();
    stageEl.innerHTML = html;
    show('steps');
  }

  function levelChip(r) {
    var l = r.level || { key: 'sin', name: '' };
    return '<span class="vd-test__chip vd-test__chip--' + esc(l.key) + '">' + esc(l.name) + '</span>';
  }

  function renderDatos() {
    var r = compute(cfg, state);
    var html = '<p class="vd-kicker">' + esc(T.dataKicker || 'Listo') + '</p>';
    html += '<h2 class="vd-h vd-h--lg" tabindex="-1" data-vd-focus>' + esc(T.dataTitle || 'Tu resultado:') + ' ' + levelChip(r) + '</h2>';
    html += '<p class="vd-test__lead">' + esc(T.dataText || '') + '</p>';
    stageEl.innerHTML = html;
    show('datos');
    if (formWrap) {
      var back = formWrap.querySelector('[data-vd-back]');
      if (!back) {
        formWrap.insertAdjacentHTML('beforeend', backBtn());
      }
    }
  }

  function bars(r) {
    return '<div class="vd-test__bars">' + ORDER.map(function (sys) {
      var s = r.scores[sys];
      var hi = (sys === r.top || sys === r.second) && s > 0;
      return '<div class="vd-test__bar' + (hi ? ' is-top' : '') + '"><span class="vd-test__bar-label">' + esc(sysCfg(sys).short) + '</span><span class="vd-test__bar-track"><i style="width:' + Math.round((s / 15) * 100) + '%"></i></span><span class="vd-test__bar-num">' + s + ' de 15</span></div>';
    }).join('') + '</div>';
  }

  function quote(text, who) {
    if (!text) return '';
    var parts = String(who || '').split(' · ');
    return '<figure class="vd-card vd-test__quote"><blockquote>“' + esc(text) + '”</blockquote><figcaption><strong>' + esc(parts[0]) + '</strong>' + (parts.length > 1 ? '<small>' + esc(parts.slice(1).join(' · ')) + '</small>' : '') + '</figcaption></figure>';
  }

  function renderResult() {
    var r = compute(cfg, state);
    var l = r.level || { key: 'sin', name: '', title: '', text: '' };
    var main = r.main;
    var own = main && main.titulo;
    var html = '<p class="vd-kicker">' + esc(T.resultKicker || 'Tu resultado') + '</p>';
    html += '<p class="vd-test__level">' + levelChip(r) + '<span>' + r.total + ' de 75 puntos</span></p>';

    if (r.alarm) {
      html += '<h2 class="vd-h vd-h--xl" tabindex="-1" data-vd-focus>' + esc(T.alarmResultTitle || 'Antes de seguir, habla con tu médico') + '</h2>';
      html += '<p class="vd-p vd-p--lg">' + nl(T.alarmResultText || '') + '</p>';
      var marked = ALARMS.filter(function (x) { return state.alarms.indexOf(x[0]) > -1; });
      if (marked.length) html += '<div class="vd-card vd-test__route"><p class="vd-plan__tag">' + esc(T.alarmListTitle || 'Cuéntale a tu médico que has tenido') + '</p><ul class="vd-test__list" style="margin-top:16px">' + marked.map(function (x) { return '<li>' + esc(x[1]) + '</li>'; }).join('') + '</ul></div>';
    } else {
      html += '<h2 class="vd-h vd-h--xl" tabindex="-1" data-vd-focus>' + esc(own || l.title) + '</h2>';
      if (!own && l.text) html += '<p class="vd-p vd-p--lg">' + nl(l.text) + '</p>';
    }

    html += '<h3 class="vd-test__sub">' + esc(T.barsTitle || 'Tu perfil por sistema') + '</h3>' + bars(r);

    var showSys = r.scores[r.top] >= 3 && l.key !== 'sin';
    if (showSys) {
      html += '<div class="vd-test__sys"><p class="vd-p">' + nl(sysCfg(r.top).message) + '</p>';
      if (r.second) html += '<p class="vd-p">' + nl(sysCfg(r.second).message) + '</p><p class="vd-p vd-test__bridge">' + esc(T.bridge || '') + '</p>';
      html += '</div>';
    }

    if (!r.alarm && main) {
      var toConsulta = main.conConsulta && cfg.consulta;
      var href = toConsulta ? cfg.consulta.url : main.url;
      html += '<div class="vd-card vd-test__route"><p class="vd-plan__tag">' + esc(T.routeTag || 'El paso que te recomiendo') + '</p>';
      html += '<p class="vd-test__route-msg">' + nl(main.msg) + (l.extra && !own ? ' ' + esc(l.extra) : '') + '</p>';
      html += '<div class="vd-actions"><a class="vd-btn vd-btn--primary" href="' + esc(href) + '">' + esc(main.btn || 'Ver más') + '</a>';
      if (toConsulta) html += '<a class="vd-btn vd-btn--secondary" href="' + esc(main.url) + '">' + esc(T.programLink || 'Ver el programa completo') + '</a>';
      html += '</div>';
      var isConsulta = cfg.consulta && (toConsulta || main.url === cfg.consulta.url);
      if (isConsulta && T.discountNote) html += '<p class="vd-test__note">' + esc(T.discountNote) + '</p>';
      if (!isConsulta && cfg.consulta && T.consultaLink) html += '<p class="vd-test__note"><a class="vd-link" href="' + esc(cfg.consulta.url) + '">' + esc(T.consultaLink) + '</a></p>';
      html += '</div>';

      r.complements.forEach(function (p) {
        html += '<div class="vd-card vd-test__comp"><p class="vd-plan__tag">' + esc(T.compTag || 'También te puede servir') + '</p><p class="vd-p">' + nl(p.compMsg) + '</p><a class="vd-link" href="' + esc(p.url) + '">' + esc(p.title) + '</a></div>';
      });

      if (showSys) {
        var sc = sysCfg(r.top);
        var useAlt = sc.altQuote && Number(state.ans[r.top + '.4'] || 0) >= 2;
        var q = useAlt ? quote(sc.altQuote, sc.altWho) : quote(sc.quote, sc.who);
        if (q) html += q + '<p class="vd-test__legal">' + esc(T.quoteLegal || '') + '</p>';
      }
    }

    html += '<p class="vd-test__legal">' + esc(T.disclaimer || '') + '</p>';
    html += '<button type="button" class="vd-test__back" data-vd-restart>Volver a hacer el test</button>';
    stageEl.innerHTML = html;
    show('resultado');
  }

  function render(skipFocus) {
    if (state.stage === 'intro') { show('intro'); return; }
    if (state.stage === 'steps') renderStep();
    else if (state.stage === 'datos') renderDatos();
    else renderResult();
    if (!skipFocus) focusTop();
  }

  function next() {
    if (state.idx < steps.length - 1) {
      state.idx += 1;
      while (skipStep(state.idx) && state.idx < steps.length - 1) { delete state.ctx[steps[state.idx].id]; state.idx += 1; }
    }
    else { state.stage = form ? 'datos' : 'resultado'; }
    save(); render();
  }

  function back() {
    if (state.stage === 'datos') { state.stage = 'steps'; state.idx = steps.length - 1; }
    else if (state.idx > 0) {
      state.idx -= 1;
      while (skipStep(state.idx) && state.idx > 0) { state.idx -= 1; }
    }
    else { state.stage = 'intro'; }
    save(); render();
  }

  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-vd-start],[data-vd-opt],[data-vd-back],[data-vd-alarm-next],[data-vd-restart]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-vd-start')) {
      ev.preventDefault();
      if (state.stage === 'intro') { state.stage = 'steps'; }
      save(); render();
    } else if (t.hasAttribute('data-vd-opt')) {
      var n = Number(t.getAttribute('data-vd-opt'));
      var st = steps[state.idx];
      if (st.type === 'ctx') {
        var c = ctxDef(st.id);
        state.ctx[c.id] = c.opts[n][0];
      } else if (st.type === 'q') {
        var q = QUESTIONS[st.sys][st.i];
        var opts = (typeof q === 'object' && q.opts) ? q.opts(state.ctx) : SCALE;
        state.ans[st.sys + '.' + st.i] = opts[n][1];
        state['sel.' + st.sys + '.' + st.i] = n;
      }
      Array.prototype.forEach.call(stageEl.querySelectorAll('[data-vd-opt]'), function (b) {
        var on = b === t; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.disabled = true;
      });
      save();
      window.setTimeout(next, reduce ? 0 : 220);
    } else if (t.hasAttribute('data-vd-back')) {
      back();
    } else if (t.hasAttribute('data-vd-alarm-next')) {
      var boxes = stageEl.querySelectorAll('[data-vd-alarm]');
      var picked = [], none = false;
      Array.prototype.forEach.call(boxes, function (b) { if (b.checked) { if (b.value === 'none') none = true; else picked.push(b.value); } });
      if (!picked.length && !none) { var er = stageEl.querySelector('[data-vd-alarm-error]'); if (er) er.hidden = false; return; }
      state.alarms = picked; state.alarmsDone = true;
      next();
    } else if (t.hasAttribute('data-vd-restart')) {
      clear(); state = fresh(); render();
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  root.addEventListener('change', function (ev) {
    var b = ev.target;
    if (!b.hasAttribute || !b.hasAttribute('data-vd-alarm')) return;
    var boxes = stageEl.querySelectorAll('[data-vd-alarm]');
    if (b.value === 'none' && b.checked) {
      Array.prototype.forEach.call(boxes, function (x) { if (x !== b) x.checked = false; });
    } else if (b.checked) {
      Array.prototype.forEach.call(boxes, function (x) { if (x.value === 'none') x.checked = false; });
    }
  });

  /* Texto visible de una respuesta de contexto (por ejemplo "40 a 49"). */
  function etiqueta(id, val) {
    var def = ctxDef(id);
    var o = def ? def.opts.filter(function (x) { return x[0] === val; })[0] : null;
    return o ? o[1] : '';
  }

  /* Datos que se guardan en el perfil de Klaviyo. No incluye las respuestas una por una ni las señales de alarma. */
  function resumen(r, pais) {
    return {
      'Test fecha': new Date().toISOString().slice(0, 10),
      'Test nivel': (r.level && r.level.name) || '',
      'Test puntaje': r.total,
      'Test sistema principal': sysCfg(r.top).short,
      'Test programa recomendado': r.main ? r.main.title : '',
      'Test digestivo': r.scores.digestivo,
      'Test nervioso': r.scores.nervioso,
      'Test hormonal': r.scores.hormonal,
      'Test metabólico': r.scores.metabolico,
      'Test muscular y articular': r.scores.muscular,
      'Test sexo': etiqueta('sexo', state.ctx.sexo),
      'Test edad': etiqueta('edad', state.ctx.edad),
      'Test tiempo con molestias': etiqueta('tiempo', state.ctx.tiempo),
      'Test ya hizo programa': state.ctx.programa === 'si',
      'Test país': pais || ''
    };
  }

  function slug(s) {
    return String(s || '').toLowerCase().normalize ? String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 30) : '';
  }

  if (form) {
    form.addEventListener('submit', function () {
      var r = compute(cfg, state);
      var tags = ['test-inflamacion', 'test-nivel-' + ((r.level && r.level.key) || 'sin'), 'test-sistema-' + r.top];
      var pais = form.querySelector('[data-vd-pais]');
      if (pais && pais.value) tags.push('pais-' + slug(pais.value));
      var wa = form.querySelector('[data-vd-wa]');
      var waNum = wa ? String(wa.value || '').replace(/[^0-9]/g, '') : '';
      if (waNum.length >= 7) tags.push('wa-' + waNum);
      var tagInput = form.querySelector('[data-vd-tags]');
      if (tagInput) tagInput.value = tags.join(', ');
      state.stage = 'resultado';
      save();
      try {
        var email = form.querySelector('input[type="email"]');
        var name = form.querySelector('[name="contact[first_name]"]');
        if (window.klaviyo && email && email.value) {
          var datos = resumen(r, pais ? pais.value : '');
          var perfil = { email: email.value, first_name: name ? name.value : '' };
          var evento = { nivel: datos['Test nivel'], puntaje: r.total, sistema: datos['Test sistema principal'], ruta: datos['Test programa recomendado'] };
          Object.keys(datos).forEach(function (k) { perfil[k] = datos[k]; evento[k] = datos[k]; });
          window.klaviyo.push(['identify', perfil]);
          window.klaviyo.push(['track', 'Completó test de inflamación', evento]);
        }
      } catch (e) {}
    });
  }

  render(true);
  if (state.stage === 'resultado' && /customer_posted|contact_posted/.test(window.location.search + window.location.hash)) {
    window.setTimeout(focusTop, 50);
  }
})();
